<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="card-title">مشاهده ی گزارش های نصاب</h6>
          </div>
          <div class="d-flex justify-content-center height" v-if="data==null" >
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">در حال بارگذاری ...</span>
            </div>
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>نام پرینت کننده</th>
                  <th>مشاهده</th>
                  <th>تاریخ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(report , index) in data" :key="index">
                  <td>{{index+1}}</td>
                  <td v-text="report.user.name"></td>
                  <td>
                      <router-link :to="{
                          name:'installer.history.report',
                          params: { id: report.pdf_id, pdf: report.id }
                        }" class="btn btn-outline-success">
                      پرینت
                    </router-link>
                  </td>
                  <td v-text="report.date">
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>ردیف</th>
                  <th>نام پرینت کننده</th>
                  <th>مشاهده</th>
                  <th>تاریخ</th>
                </tr>
              </tfoot>
            </table>
            <paginations :count="pagination.count" :current="pagination.currentPage" v-on:pages="page"></paginations>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import pagination from '@/mixins/pagination.js'
import paginations from '@/components/partials/paginations.vue'
export default {
  name: 'InstallerProjectsReportsHistory',
  mixins: [pagination],
  components: {
    paginations
  },
  data () {
    return {
      data: null,
      url: 'api/installer/report/' + this.$route.params.id + '/history',
      what: null,
      type: 'post'
    }
  }
}

</script>
